var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { COLOR } from '../../../theme/colors';
import { TYPOGRAPHY_TYPE, getTypographyStyles } from '../../../theme/typography';
export const BlockQuote = (_a) => {
    var { sx } = _a, props = __rest(_a, ["sx"]);
    return (_jsx("blockquote", Object.assign({}, props, { sx: Object.assign(Object.assign({ ml: 5, borderLeft: '8px solid', borderColor: COLOR.ND_BLUE_BRIGHT, p: 4, color: COLOR.GRAY }, getTypographyStyles(TYPOGRAPHY_TYPE.PARAGRAPH_LARGE)), sx) })));
};
